import { VesselDto } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { VesselAutocompleteViewStore } from '@planning/stores/vessel/VesselAutocompleteViewStore'
import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps, VesselIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

type Props = {
  store: VesselAutocompleteViewStore
  value?: any
  validate?: () => void
} & TomAutoCompleteProps<VesselDto>

export const VesselAutoComplete: FC<Props> = observer(props => {
  const { store, label, dataCy, sx, onChangeEntity, validate } = props
  const { t } = useTranslate()
  const { appViewStore } = usePlanningStore()

  return (
    <TomAutoComplete
      {...props}
      sx={sx ?? { mb: '1rem' }}
      label={label ?? t('vessel', 'Vessel')}
      entityKey='id'
      entityDisplayValue={'name'}
      options={store.options}
      loading={appViewStore.isLoading}
      validate={validate}
      onChangeEntity={entity => {
        if (!entity) {
          store.setOptions([])
          return
        }

        onChangeEntity?.(entity)
      }}
      onChangeFilter={filter => {
        if (!filter) {
          store.setOptions([])
          return
        }

        store.filterOptions(filter)
      }}
      startAdornment={<VesselIcon />}
      dataCy={dataCy ?? 'vessel-autocomplete'}
    />
  )
})
